module.exports = __webpack_public_path__ + "static/media/6.4.e306f547.png";